import { useState, useEffect } from 'react';

// Tracks a max-width media query so layouts that need to switch structure
// (not just resize via CSS — e.g. showing one pane at a time instead of
// three side by side) can branch in JS. Default matches Navbar.css's mobile
// breakpoint.
export function useIsMobile(breakpoint = 768) {
    const query = `(max-width: ${breakpoint}px)`;
    const [isMobile, setIsMobile] = useState(
        () => typeof window !== 'undefined' && window.matchMedia(query).matches
    );

    useEffect(() => {
        const mql = window.matchMedia(query);
        const onChange = (e) => setIsMobile(e.matches);
        setIsMobile(mql.matches);
        mql.addEventListener('change', onChange);
        return () => mql.removeEventListener('change', onChange);
    }, [query]);

    return isMobile;
}
